<template>
  <div class="col-12 editable-table-container">
    <div class="editable-table-wrapper">
      <EditableTable bordered class="editable-table" v-model="items" :fields="fields" @input-change="handleInput">
        <template #cell(delete)="data">
          <BIconX class="remove-icon" @click="handleDelete(data)"></BIconX>
        </template>
      </EditableTable>
    </div>
    <div class="d-flex">
      <MiniToolbar class="p-2 mr-auto" :buttons="tableEditorToolbar" @clicked="toolbarClicked"/>
    </div>
  </div>
</template>

<script>
import MiniToolbar from '@/components/MiniToolbar.vue'
import EditableTable from '@/components/EditableTable.vue'
import {BIconX} from 'bootstrap-vue'

export default {
  components: {
    MiniToolbar,
    EditableTable,
    BIconX
  },
  data () {
    return {
      tableEditorToolbar: [
        {
          icon: 'sli-plus',
          id: 'table-editor-add',
          tip: 'discussion.add_drug',
          small: true
        },
        {
          icon: 'sli-close',
          id: 'table-editor-cancel',
          tip: 'discussion.cancel',
          small: true
        },
        {
          icon: 'sli-check',
          id: 'table-editor-ok',
          tip: 'discussion.ok'
        }
      ],
      fields: [
        { key: 'name', label: this.$t('discussion.drug_name'), type: 'text', editable: true, placeholder: this.$t('discussion.enter_name_placeholder'), class: 'name-col' },
        { key: 'description', label: this.$t('discussion.description'), type: 'text', editable: true, placeholder: this.$t('discussion.enter_description_placeholder'), class: 'description-col' },
        { key: 'delete', label: '' }
      ],
      items: [
        {}
      ]
    }
  },
  methods: {
    toolbarClicked: function (id, button) {
      switch (button.icon) {
        case 'sli-close':
          this.$emit('canceled')
          break
        case 'sli-plus':
          if (this.items.length >= 15) {
            return
          }
          this.items.push({})
          break
        case 'sli-check':
          this.$emit('ok', this.items)
          break
      }
    },
    handleInput (value, data) {},
    handleDelete (data) {
      this.items.splice(data.index, 1)
    }
  }
}
</script>

<style>
.editable-table-wrapper {
  width: 100%;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}

table.editable-table {
  margin: auto;
  width: 100% !important;
}

table.editable-table td {
  vertical-align: middle;
}

.editable-table .data-cell {
  padding: 8px;
  vertical-align: middle;
}

.editable-table .custom-checkbox {
  width: 50px;
}

.name-col {
  width: 120px;
}

.department-col {
  width: 150px;
}

.age-col {
  width: 100px;
}

.date-col {
  width: 200px;
}

.is-active-col {
  width: 100px
}
</style>



// WEBPACK FOOTER //
// src/views/DiscussionTableEditor.vue